import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EmailInput = ({ value, errorMessage, onChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <label htmlFor="email" className="sr-only">
        {t("customHRD.emailLabel")}
      </label>

      {errorMessage && (
        <p id="email-error" className="hrd-error-message" role="alert">
          {errorMessage}
        </p>
      )}

      <input
        id="email"
        name="email"
        type="email"
        className={`hrd-input ${errorMessage ? "hrd-input-error" : ""}`}
        placeholder={t("customHRD.emailPlaceholder")}
        value={value}
        maxLength={254}
        autoComplete="username"
        onChange={onChange}
        aria-invalid={errorMessage ? "true" : "false"}
        aria-describedby={errorMessage ? "email-error" : undefined}
      />
    </>
  );
};

EmailInput.propTypes = {
  value: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default EmailInput;